<script lang="ts">
	import { run } from "svelte/legacy"

	import { DataHandlerCalibration, type Calibration, type Device } from "luxedo-data"
	import CalibrationListEntry from "./CalibrationListEntry.svelte"
	import { Responsive } from "responsive"

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	let calibrationList: Array<Calibration> = $state([])

	let isMobile = $derived(Responsive.isMobile)
	let listWidth: number = $state()

	let tileWidth: number = $derived.by(() => {
		if (!listWidth) return

		const width = listWidth - 16 * 3

		const TILE_WIDTH_PREFFERED = isMobile ? 72 : 96
		const TILE_MARGIN = isMobile ? 8 : 16

		const tileAmountPerRow = Math.floor(width / (TILE_WIDTH_PREFFERED + TILE_MARGIN))
		const newTileWidth = Math.floor(width / tileAmountPerRow) - TILE_MARGIN

		return newTileWidth
	})

	let calListElement: HTMLDivElement = $state()

	DataHandlerCalibration.addListener(updateCalibrationList)

	function updateCalibrationList() {
		if (!device) return

		calibrationList =
			DataHandlerCalibration.filterByDevice(device)
				.filter((cal) => !cal.didFail)
				.sort((calA, calB) => {
					if (calA.runTime > calB.runTime) return -1
					else if (calA.runTime < calB.runTime) return 1
					else return 0
				}) ?? []

		setTimeout(() => {
			expandFirstSnapshots()
		})
	}

	function expandFirstSnapshots() {
		const header: HTMLDivElement = calListElement?.querySelector(".section-header")

		header?.click()
	}

	run(() => {
		device && updateCalibrationList()
	})
</script>

<div
	class="calibration-list"
	class:isMobile
	bind:clientWidth={listWidth}
	bind:this={calListElement}
	style="--tile-width: {tileWidth}px;"
>
	{#each calibrationList as cal (cal.id)}
		<CalibrationListEntry calibration={cal} />
	{/each}
</div>

<style>
	.calibration-list {
		--mask-preview-height: 8rem;
		background-color: var(--color-bg-dark);
		width: 100%;
		/* overflow-x: hidden;
		overflow-y: scroll; */
		position: relative;
		padding: 0 1rem 1rem 1rem;
		border-radius: var(--br);
		box-sizing: border-box;
	}

	.calibration-list.isMobile {
		padding: 0 0.5rem;
	}

	.calibration-list::-webkit-scrollbar-thumb {
		background-color: var(--color-bg);
	}
</style>
